import Vue from "vue";
import Router from "vue-router";
import Home from "@views/Home";
import Works from "@views/Works";
import Work from "@views/Work";
import Page from "@views/Page";
import NotFound from "@views/404";

import store from "@config/store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          x: 0,
          y: 0,
        });
      }, 600);
    });
  },
  routes: [
    {
      path: "/",
      redirect: {
        name: "home",
        params: {
          locale: localStorage.getItem("currentLocale"),
        },
      },
    },
    {
      path: "/:locale/",
      component: {
        render: function(createElement) {
          return createElement("router-view");
        },
      },
      children: [
        {
          path: "",
          name: "home",
          component: Home,
        },
        {
          path: "cosa",
          name: "cosa",
          alias: "what",
          component: Works,
        },
        {
          path: "cosa/:slug",
          name: "work",
          alias: "what/:slug",
          component: Work,
        },
        {
          path: "404",
          name: "404",
          component: NotFound,
        },
        {
          path: ":page",
          name: "page",
          component: Page,
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.commit("changeMenuStatus", false);
  var locales = store.getters.getLocales;
  var locale = "";
  if (locales.includes(to.params.locale)) {
    locale = to.params.locale;
    if (localStorage.getItem("currentLocale") !== locale) {
      store.commit("changeLocale", locale);
    }
    if (to.name !== "home") {
      sessionStorage.skipIntro = true;
    }
    next();
  } else {
    locale = "it";
    next({ name: "home", params: { locale } });
  }
});

router.afterEach((to, from) => {
  if (document.getElementsByTagName("body")[0].classList.contains("is-intro")) {
    document.getElementsByTagName("body")[0].classList.remove("is-intro");
  }
});
export default router;
